import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";

@Component({
    template: require("./template.html")
})
class EmailsComponent extends Vue {
  @Prop()
  emails: string;

  get NextEmails() {
    if (this.emails) {
      let result = this.emails.split(",");

      result.shift(); // remove first phone

      return result;
    }

    return [];
  }

  get FirstEmail() {
    if (this.emails) {
      return this.emails.split(",")[0];
    }

    return "";
  }
}

export default EmailsComponent;
